<template>
    <!-- :card-data="data" -->
  <card-template
    :card-title="data.cardName"
    :is-loading="isLoading"
    :card-info="getCardInfo()"
    card-type="CONSISTENCIES"
  ></card-template>
</template>

<script>
import CardTemplate from './card-template.vue'
import supervisorStorage from '../../storage/supervisorStorage'

export default {
  name: 'card-consistences',
  methods: {
    getCardInfo () {
      const consistent = supervisorStorage.getConsistencyCorrectLogs()
      const total = supervisorStorage.getSupervisorFtpFiles().length
      const inconsistent = total - consistent

      const percentageConsistency = consistent / total
      if (this.isLoading) {
        return {
          lightColor: 'gray',
          cardNumber: 0,
          message: 'Verificando archivos'
        }
      }
      if (total === consistent) {
        return {
          lightColor: 'green',
          cardNumber: 0,
          message: 'Correcto, todos los archivos son consistentes'
        }
      }
      if (percentageConsistency > 0.9) {
        return {
          lightColor: 'amber',
          cardNumber: inconsistent,
          // message: `de ${total} distribuidora(s) tiene(n) archivos con inconsistencias`
          message: `de ${total} distribuidora(s) tiene(n) archivos inconsistentes`
        }
      }
      return {
        lightColor: 'red',
        cardNumber: inconsistent,
        message: `de ${total} distribuidora(s) tiene(n) archivos inconsistentes`
      }
    }
  },
  props: {
    isLoading: {
      type: Boolean,
      default () {
        return true
      }
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  components: {
    CardTemplate
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/supervisor/card-consistencies.vue